import { WLOrderFormProvider, type Security } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

const getStrategiesBySymbol = (s: Security) => s.SupportedStrategies ?? [];

export function WhitelabelOrderFormProvider({ children }: PropsWithChildren) {
  return <WLOrderFormProvider getStrategiesBySymbol={getStrategiesBySymbol}>{children}</WLOrderFormProvider>;
}
